"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fscreen = _interopRequireDefault(require("fscreen"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactBodyClassname = _interopRequireDefault(require("react-body-classname"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _reactHotkeys = require("react-hotkeys");

var _fullscreen = _interopRequireDefault(require("../../../fullscreener/fullscreen.service"));

var _preloader = require("../../../helpers/preloader/preloader");

// fscreen is Vendor agnostic access to the Fullscreen API
class Fullscreen extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      isFull: false,
      tooltipMessage: this.props.texts.fullscreenOff
    });
    (0, _defineProperty2.default)(this, "handler", () => {
      const isFullNow = _fscreen.default.fullscreenElement !== null;
      const {
        fullscreenOn,
        fullscreenOff
      } = this.props.texts;

      if (isFullNow !== this.state.isFull) {
        this.setState({
          isFull: isFullNow,
          tooltipMessage: isFullNow ? fullscreenOn : fullscreenOff
        });
      }
    });
    (0, _defineProperty2.default)(this, "toggle", () => {
      const {
        onFullscreen,
        onFullscreenExit
      } = this.props.callbacks;

      if (this.state.isFull) {
        _fullscreen.default.exit().then(() => {
          onFullscreenExit({
            where: 'button'
          });
        });
      } else {
        _fullscreen.default.request(this.props.container).then(() => {
          onFullscreen({
            where: 'button'
          });
        }).catch(() =>
        /* reason */
        {// console.log('did not go fullscreen', reason.message);
        });
      }

      this.props.onInteraction();
    });
    (0, _defineProperty2.default)(this, "keyMap", {
      FULL_SCREEN: ['f', 'shift+f', 'F', 'shift+F']
    });
    (0, _defineProperty2.default)(this, "handlers", {
      FULL_SCREEN: event => {
        event.preventDefault();
        this.toggle();
      }
    });
  }

  componentDidMount() {
    _fscreen.default.addEventListener('fullscreenchange', this.handler);

    (0, _preloader.preloadFromCSSVars)(this.control);
  }

  componentWillUnmount() {
    _fscreen.default.removeEventListener('fullscreenchange', this.handler);
  }

  render() {
    if (!_fullscreen.default.isSupported) {
      return null;
    }

    const {
      tooltipMessage,
      isFull
    } = this.state;
    const {
      isCollapsed,
      hasToolTip
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHotkeys.GlobalHotKeys, {
      keyMap: this.keyMap,
      handlers: this.handlers
    }), hasToolTip && /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
      id: "fullscreen-tooltip",
      effect: "solid",
      place: isCollapsed ? 'left' : 'top',
      getContent: () => tooltipMessage,
      className: "fullscreen__tooltip"
    }), /*#__PURE__*/_react.default.createElement("button", {
      ref: el => {
        this.control = el;
      },
      type: "button",
      className: (0, _classnames.default)('fullscreen', {
        'fullscreen--active': isFull
      }),
      onClick: this.toggle,
      "data-tip": "",
      "data-for": "fullscreen-tooltip"
    }), /*#__PURE__*/_react.default.createElement(_reactBodyClassname.default, {
      className: (0, _classnames.default)({
        'is-fullscreen': isFull
      })
    }));
  }

}

Fullscreen.propTypes = {
  container: _propTypes.default.instanceOf(global.Element),
  callbacks: _propTypes.default.shape({
    onFullscreen: _propTypes.default.func,
    onFullscreenExit: _propTypes.default.func
  }),
  onInteraction: _propTypes.default.func.isRequired,
  texts: _propTypes.default.shape({
    fullscreenOn: _propTypes.default.string,
    fullscreenOff: _propTypes.default.string
  }),
  isCollapsed: _propTypes.default.bool,
  hasToolTip: _propTypes.default.bool
};
Fullscreen.defaultProps = {
  container: null,
  callbacks: {
    onFullscreen: () => {},
    onFullscreenExit: () => {}
  },
  texts: {
    fullscreenOn: 'Exit full screen (f)',
    fullscreenOff: 'Full screen (f)'
  },
  isCollapsed: false,
  hasToolTip: false
};
var _default = Fullscreen;
exports.default = _default;